import React from 'react';
import CompleteRegistrationForm from 'components/forms/CompleteRegistrationForm';
import { dehydrate, QueryClient, useQuery } from 'react-query';
import { fetchAreas } from 'data/fetchers';
import { withAuthGuard } from 'components/auth/withAuthGuard';

export async function getStaticProps() {
    const queryClient = new QueryClient();
    await queryClient.prefetchQuery('areas', () => fetchAreas());

    return {
        props: {
            dehydratedState: dehydrate(queryClient),
            revalidate: 60 * 60 * 24
        }
    };
}

const CompleteRegistrationPage = () => {
    const { data: areas } = useQuery('areas', () => fetchAreas());

    return (
        <div className="container max-w-md mx-auto pt-8 sm:pt-12 pb-24">
            <h2 className="text-center">Samo še en korak in tvoj KZV račun bo aktiven</h2>
            <p className="text-center mt-2 mb-6">
                Preveri in po potrebi popravi spodnje podatke ter zaključi registracijo.
            </p>

            <CompleteRegistrationForm municipalities={areas?.data.filter((area) => area.type.key === 'municipality')} />
        </div>
    );
};

export default withAuthGuard(CompleteRegistrationPage);
